import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "restore-password" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "form-group progress-bar" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Change Password", -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers($setup.submitForm, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "New password", -1)),
            _createVNode($setup["InputPassword"], {
              modelValue: $setup.form.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.password) = $event)),
              "input-classes": ['input-large', { 'input--error': $setup.v$.password.$error }],
              placeholder: "New password"
            }, null, 8, ["modelValue", "input-classes"])
          ]),
          ($setup.v$.password.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.password.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", null, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "label" }, "Confirm new password", -1)),
            _createVNode($setup["InputPassword"], {
              modelValue: $setup.form.confirmPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.confirmPassword) = $event)),
              "input-classes": ['input-large', { 'input--error': $setup.v$.confirmPassword.$error }],
              placeholder: "Confirm new password"
            }, null, 8, ["modelValue", "input-classes"]),
            ($setup.v$.confirmPassword.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.v$.confirmPassword.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode($setup["PasswordProgress"], {
            password: $setup.form.password
          }, null, 8, ["password"]),
          ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.errorMessage), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-group" }, [
          _createElementVNode("button", { class: "button primary large w-100" }, "Confirm")
        ], -1))
      ], 32)
    ])
  ]))
}